// SVG logo mark — matches the mobile app's logo-small.svg
export default function LogoMark({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.71" y="3.71" width="7.42" height="7.42" stroke="#00263E" strokeWidth="7.42" strokeLinejoin="round"/>
      <path d="M13.26 10.34a2.92 2.92 0 1 1-5.84 0 2.92 2.92 0 0 1 5.84 0Z" fill="#F2C94C"/>
      <path d="M14.85 3.71L8.49 7.39V0.04L14.85 3.71Z" fill="#2BC48A"/>
      <path d="M2.12 6.89h4.77v6.37H2.12V6.89Z" fill="#FF7F50"/>
      <path d="M7.42 3.71a2.65 2.65 0 1 1-5.3 0 2.65 2.65 0 0 1 5.3 0Z" fill="#3DA9FC"/>
    </svg>
  );
}
